export const API_URL = "https://dynaslope.com.ph:5001";
export const STORAGE_URL = "https://dynaslope.com.ph:7000";
